<template>
  <div>
    <Multiselect
      @input="onChangeTime"
      :show-labels="false"
      v-model="appointmenttime"
      label="name"
      :searchable="false"
      placeholder=""
      :allow-empty="false"
      :options="timeOptions"
      :disabled="['installation', 'so'].includes($store.state.privilege.role)"
    >
      <template slot="option" slot-scope="props">
        <div>{{ props.option.name }}</div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import moment from 'moment'
import api from '@/api'

export default {
  props: ['valuedata', 'appointmentData', 'current_appointmenttime', 'appointmentdate'],
  components: {
    Multiselect
  },
  data() {
    return {
      tempdata: '',
      item: this.valuedata
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    current_appointmenttimedata: {
      get() {
        return this.current_appointmenttime
      },
      set(val) {
        return this.$emit('update:current_appointmenttime', val)
      }
    },
    timeOptions() {
      var day = moment(this.appointmentdate).format('dddd')
      var quota = ['Sunday', 'Saturday'].includes(day) ? 4 : 5
      var formattedday = moment(this.appointmentdate).format('YYYY-MM-DD')
      var data = this.appointmentData[formattedday]
      if (data) {
        var timetotal = data[this.current_appointmenttimedata]
        var morning = data.hasOwnProperty('เช้า') ? quota - data['เช้า'] : quota
        var afternoon = data.hasOwnProperty('บ่าย') ? quota - data['บ่าย'] : quota
        return [
          { name: `เช้า`, quota: morning /* , $isDisabled: morning <= 0 */ },
          { name: `บ่าย`, quota: afternoon /* , $isDisabled: afternoon <= 0 */ }
        ]
      } else {
        return [
          { name: `เช้า`, quota },
          { name: `บ่าย`, quota }
        ]
      }
    },
    appointmenttime: {
      get() {
        return { name: this.current_appointmenttimedata }
      },
      set(val) {
        this.current_appointmenttimedata = val.name
      }
    }
  },
  mounted() {
    // this.item = this.valuedata
    this.tempdata = this.current_appointmenttimedata
  },
  methods: {
    onChangeTime(val) {
      var data = {
        pageid: this.selectedBot.pageid,
        orderid: this.item.id,
        appointmentdate: moment(this.appointmentdate).format('YYYY-MM-DD'),
        appointmenttime: val.name
      }
      this.$store.dispatch('loading')
      api.kingkitchenapplyAppointmentTimeToOrder(data, (err, response) => {
        if (response && response.responsecode == 200) {
          this.tempdata = val.name
          this.$emit('onsavedata')
        } else {
          this.appointmenttime = this.tempdata
        }
        this.$store.dispatch('loading')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/AppointmentTimeSelect.vue